import Text from "@/components/Text";
import Theme from "@/utils/theme";
import ShapedAccordion from "@/components/ShapedAccordion";
import { Box, useMediaQuery } from "@mui/material";
import Spacer from "@/components/Spacer";
import Button from "@/components/Button";
import ChallengeSubmissionWrapper from "@/layout/ChallengeSubmissionWrapper";
import { OutlinedBox } from "./styles";
import QuizIcon from "/assets/icons/quiz.svg";
import QuizQuestionsDialog from "../QuizQuestionsDialog";
import Chip from "@/components/Chip";
import Divider from "@/components/Divider";
import { useCaseChallengeSubmission } from "./useQuizChallengeSubmission";

function mapQuizStatusToChip(statusText: string) {
  const normalized = statusText.toLowerCase();
  if (normalized.includes("enviad")) {
    return {
      label: "Enviado",
      color: Theme.colors.feedback.info,
      textColor: Theme.colors.neutral.lightest,
    };
  }
  if (normalized.includes("conclu")) {
    return {
      label: "Concluído",
      color: Theme.colors.feedback.positive,
      textColor: Theme.colors.neutral.lightest,
    };
  }

  return {
    label: "Pendente",
    color: Theme.colors.feedback.warning,
    textColor: Theme.colors.neutral.dark,
  };
}

function CaseChallengeSubmission() {
  const {
    challenge,
    challengeStatus,
    quizzes,

    currentQuiz,
    setIsOpenQuizId,
  } = useCaseChallengeSubmission();

  const isMobile = useMediaQuery("(max-width:600px)");

  return (
    <ChallengeSubmissionWrapper type="case">
      <ShapedAccordion
        summaryStyle={{ backgroundColor: Theme.colors.brand.secondary }}
        fixedIndex={0}
        items={[
          {
            summary: (
              <Box display="flex" alignItems="center">
                <Text color={Theme.colors.neutral.dark}>Cases</Text>
                <Text color={Theme.colors.neutral.mid}> | </Text>
                <Chip
                  label={challengeStatus.text}
                  color={challengeStatus.color}
                />
              </Box>
            ),

            details: (
              <Box display="flex" flexDirection="column" p="1.5rem" flex={1}>
                <Box
                  border={`1px solid ${Theme.colors.neutral.mid}`}
                  borderRadius="0.5rem"
                  p="1rem"
                >
                  {quizzes?.map((quiz, index) => {
                    const statusChip = mapQuizStatusToChip(quiz.status.text);
                    return (
                      <>
                        <OutlinedBox>
                          <img src={QuizIcon} />
                          <Text ml={1} color={Theme.colors.neutral.dark}>
                            Case 0{quiz.order}
                            <Divider vertical />
                          </Text>

                          <Chip
                            label={statusChip.label}
                            color={statusChip.color}
                            textColor={statusChip.textColor}
                            size="small"
                            sx={{ ml: "0.2rem", mr: "0.2rem" }}
                          />

                          <Spacer grow />

                          <Button
                            variant="outlined"
                            fullWidth={isMobile}
                            onClick={() => {
                              setIsOpenQuizId(quiz.id);
                            }}
                            style={{ padding: "0.2rem 1rem" }}
                          >
                            {quiz?.submission ? "Detalhes" : "Iniciar Case"}
                            <Spacer width="0.5rem" />
                            {">"}
                          </Button>
                        </OutlinedBox>

                        {index !== (challenge?.quizzes?.length ?? 0) - 1 && (
                          <Spacer height="1rem" />
                        )}

                        <QuizQuestionsDialog
                          isOpen={currentQuiz?.id === quiz.id}
                          challenge={currentQuiz!}
                          onClose={() => setIsOpenQuizId(undefined)}
                        />
                      </>
                    );
                  })}
                </Box>
              </Box>
            ),
            shadowColor: "#FECC09",
          },
        ]}
      />
    </ChallengeSubmissionWrapper>
  );
}

export default CaseChallengeSubmission;
